import { ReportType, ApprovalState } from "@fdm/api-client";
import { ReportFormPage } from "../../report-form-control.service";

export const OWNER_OPERATOR_ADVISOR = {
    [ReportType.AnomalyReport]: {
      [ReportFormPage.ACTION_ITEM]: [
        ApprovalState.Draft,
        ApprovalState.DraftedForReview,
        ApprovalState.RIPTScored,
        // ApprovalState.RIPTScoredSkipped,
        ApprovalState.PlanApproved,
        ApprovalState.PlanConfirmed,
        ApprovalState.PlanEndorsed,
      ],
      [ReportFormPage.NOTES_ATTACHMENTS]: [
        ApprovalState.Draft,
        ApprovalState.DraftedForReview,
        ApprovalState.PlanConfirmed,
        ApprovalState.PlanEndorsed,
        ApprovalState.PlanApproved,
        ApprovalState.RIPTScored,
        // ApprovalState.ResolutionPlanCompleted,
      ],
    },
    [ReportType.IntegrityDeficiency]: {
      [ReportFormPage.ACTION_ITEM]: [
        ApprovalState.Draft,
        ApprovalState.DraftedForReview,
        ApprovalState.SubmittedToOpsAdvisor,
        ApprovalState.PlanApproved,
        ApprovalState.PlanConfirmed,
        ApprovalState.RIPTScored,
        ApprovalState.PlanEndorsed,
        ApprovalState.RiskEvaluationScored,
      ],
      [ReportFormPage.NOTES_ATTACHMENTS]: [
        ApprovalState.Draft,
        ApprovalState.DraftedForReview,
        ApprovalState.SubmittedToOpsAdvisor,
        ApprovalState.PlanConfirmed,
        ApprovalState.PlanEndorsed,
        ApprovalState.PlanApproved,
        ApprovalState.RIPTScored,
        ApprovalState.RiskEvaluationScored,
        ApprovalState.ResolutionPlanCompleted,
        ApprovalState.ValidationAndVerificationCompleted,
      ],
      [ReportFormPage.RISK_EVALUATION]: [
        ApprovalState.SubmittedToOpsAdvisor
      ]
    },
    [ReportType.ReliabilityDeficiency]: {
      [ReportFormPage.ACTION_ITEM]: [
        ApprovalState.Draft,
        ApprovalState.DraftedForReview,
        ApprovalState.SubmittedToOpsAdvisor,
        ApprovalState.PlanApproved,
        ApprovalState.PlanConfirmed,
        ApprovalState.RIPTScored,
        ApprovalState.PlanEndorsed,
        ApprovalState.RiskEvaluationScored,
      ],
      [ReportFormPage.NOTES_ATTACHMENTS]: [
        ApprovalState.Draft,
        ApprovalState.DraftedForReview,
        ApprovalState.SubmittedToOpsAdvisor,
        ApprovalState.PlanConfirmed,
        ApprovalState.PlanEndorsed,
        ApprovalState.PlanApproved,
        ApprovalState.RIPTScored,
        ApprovalState.RiskEvaluationScored,
        ApprovalState.ResolutionPlanCompleted,
        ApprovalState.ValidationAndVerificationCompleted,
      ],
      [ReportFormPage.RISK_EVALUATION]: [
        ApprovalState.SubmittedToOpsAdvisor
      ]
    },
    [ReportType.IntegrityThreat]: {
      [ReportFormPage.ACTION_ITEM]: [
        ApprovalState.Draft,
        ApprovalState.DraftedForReview,
        ApprovalState.SubmittedToOpsAdvisor,
        ApprovalState.PlanConfirmed,
        ApprovalState.RIPTScored,
        ApprovalState.PlanEndorsed,
        ApprovalState.PlanApproved,
      ],
      [ReportFormPage.NOTES_ATTACHMENTS]: [
        ApprovalState.Draft,
        ApprovalState.DraftedForReview,
        ApprovalState.SubmittedToOpsAdvisor,
        ApprovalState.PlanConfirmed,
        ApprovalState.PlanEndorsed,
        ApprovalState.PlanApproved,
        ApprovalState.RIPTScored,
        // ApprovalState.ResolutionPlanCompleted,
      ],
    },
    [ReportType.ReliabilityThreat]: {
      [ReportFormPage.ACTION_ITEM]: [
        ApprovalState.Draft,
        ApprovalState.DraftedForReview,
        ApprovalState.SubmittedToOpsAdvisor,
        ApprovalState.PlanConfirmed,
        ApprovalState.RIPTScored,
        ApprovalState.PlanEndorsed,
        ApprovalState.PlanApproved,
      ],
      [ReportFormPage.NOTES_ATTACHMENTS]: [
        ApprovalState.Draft,
        ApprovalState.DraftedForReview,
        ApprovalState.SubmittedToOpsAdvisor,
        ApprovalState.PlanConfirmed,
        ApprovalState.PlanEndorsed,
        ApprovalState.PlanApproved,
        ApprovalState.RIPTScored,
        // ApprovalState.ResolutionPlanCompleted,
      ],
    },
    [ReportType.TaskDeferral]: {
      [ReportFormPage.ACTION_ITEM]: [
        ApprovalState.Draft,
        ApprovalState.DraftedForReview,
        ApprovalState.SubmittedToOpsAdvisor,
        ApprovalState.PlanApproved,
        ApprovalState.PlanConfirmed,
        ApprovalState.PlanEndorsed,
        ApprovalState.RiskEvaluationScored,
      ],
      [ReportFormPage.NOTES_ATTACHMENTS]: [
        ApprovalState.Draft,
        ApprovalState.DraftedForReview,
        ApprovalState.SubmittedToOpsAdvisor,
        ApprovalState.PlanConfirmed,
        ApprovalState.PlanEndorsed,
        ApprovalState.PlanApproved,
        ApprovalState.RiskEvaluationScored,
      ],
      [ReportFormPage.RISK_EVALUATION]: [
        ApprovalState.SubmittedToOpsAdvisor
      ]
    },
  }